import { BrowserRouter, Route, Switch, useLocation } from "react-router-dom";
import { createContext, useEffect, useRef, useState } from "react";
import { Provider } from "react-redux";
import store from "../Services/Redux/store";
import { DataProvider } from "../Services/Context-Api/Context";
import { PrimeReactProvider } from "primereact/api";
import { LoaderProvider } from "../Services/Loader_Provider_Service/LoadingContext";
import TosterService from "../Services/Toster-Service/TosterService";
import Sidebar from "../Shared/Sidebar/SharedSidebar";
import Header from "../Shared/Sidebar/Header";
import ProtectedRoute from "../Routes/AuthGard/ProtectedRoute";
import UserNotexit from "../Component/Auth/Login/UserNotexit/InvalidUser";
import SignUp from "../Component/Auth/SignUp/SignUp";
import LoginByPassword from "../Component/Auth/Login/LoginByPassword";
import AboutOrggenieMobileAccess from "../Component/Home/AboutOrggenie/AboutOrggenieMobileAccess";
import Pagenotfound from "../Component/404page/404";
import UserAuthorisation from "../Component/404page/UserAuthorisation";
import Dashboard from "../Component/Home/Dashboard/Dashboard";
import OnBoardingDashboard from "../Component/Home/Dashboard/OnBoardingDashboard";
import AdvanceSetting from "../Component/Home/AdvanceSetting/AdvanceSetting";
import ManageUser from "../Component/Home/EmployeeList/ManageUser";
import MainGallery from "../Component/Home/Gallery/Main_Gallery";
import AddMedia from "../Component/Home/Gallery/AddMedia";
import SingleGallery from "../Component/Home/Gallery/SingleGallery/SingleGallery";
import CreateAlbum from "../Component/Home/Gallery/CreateAlbum";
import Policylist from "../Component/Home/Policy/Policylist";
import Policydetail from "../Component/Home/Policy/Policydetail";
import AddPolicy from "../Component/Home/Policy/AddPolicy";
import Notification from "../Component/Home/Notifications/Notifications";
import TeamDirectory from "../Component/Home/TeamDirectory/TeamDirectory";
import ApplyLeave from "../Component/Home/ApplyLeave/ApplyLeave";
import UserProfile from "../Component/Home/MyProfile/UserProfile";
import MyLeave from "../Component/Home/ApplyLeave/MyLeave";
import OrganizationLeave from "../Component/Home/ApplyLeave/OrganizationLeave";
import EmployeeList from "../Component/Home/EmployeeList/EmployeeList";
import AddNewEmployee from "../Component/Home/EmployeeList/AddNewEmployee";
import Announcement from "../Component/Home/Announcement/Announcement";
import AnnouncementDetail from "../Component/Home/Announcement/AnnouncementDetail";
import AnnouncementEdit from "../Component/Home/Announcement/AnnouncementEdit";
import AwardList from "../Component/Home/AwardList/AwardList";
import AddAward from "../Component/Home/AwardList/AddAward";
import AwardDetails from "../Component/Home/AwardList/AwardDetails";
import ProjectDetail from "../Component/Home/ProjectDetails/ProjectDetail";
import Celebrations from "../Component/Home/Celebrations/Celebrations";
import ChangePassword from "../Component/Auth/Chnage-Password/ChangePassword";
import ForgotPassword from "../Component/Auth/Chnage-Password/ForgotPassword";
import OTPVerification from "../Component/Auth/Chnage-Password/OTPVerification";
import MyLeaveCompletedLeave from "../Component/Home/ApplyLeave/MyLeaveCompletedLeave";
import MyLeavePendingLeave from "../Component/Home/ApplyLeave/MyLeavePendingLeave";
import TeamLeave from "../Component/Home/ApplyLeave/TeamLeave";
import ApplyLeaveForOther from "../Component/Home/ApplyLeave/LeaveForOther/LeaveForOther";
import LeaveAdjustment from "../Component/Home/ApplyLeave/LeaveAdjustment/LeaveAdjustment";
import WFHForOther from "../Component/Home/ApplyLeave/LeaveForOther/WFHForOther";
import WFHAdjustment from "../Component/Home/ApplyLeave/LeaveAdjustment/WFHAdjustment";
import FeaturedPost from "../Component/Home/Dashboard/PostsCommonSlider/FeaturedPost";
import FeedDetails from "../Component/Home/Dashboard/FeedDetail/FeedDetails";
import MyLedger from "../Component/Home/ApplyLeave/MyLedger";
import WFHLedger from "../Component/Home/ApplyLeave/Wfh/WFHLedger";
import Reminders from "../Component/Home/CreateReminders/Reminders";
import CreateReminders from "../Component/Home/CreateReminders/CreateReminders";
import TeamGallery from "../Component/Home/Gallery/TeamGallery/TeamGallery";
import CommunicationPanel from "../Component/Home/CommunicationPanel/CommunicationPanel";
import MyWfh from "../Component/Home/ApplyLeave/Wfh/MyWfh";
import MyWfhCompleted from "../Component/Home/ApplyLeave/Wfh/MyWfhCompletedWfh";
import MyPendingWfh from "../Component/Home/ApplyLeave/Wfh/MyPendingwfh";
import WfhDashboard from "../Component/Home/ApplyLeave/Wfh/WfhDashboard";
import TeamWfh from "../Component/Home/ApplyLeave/Wfh/TeamWfh";
import SearchResult from "../Component/Home/SearchResult/SearchResult";
import SendUsFeedback from "../Component/Home/Dashboard/SendUsFeedback/SendUsFeedback";
import RaiseaFlag from "../Component/Home/Dashboard/RaiseaFlag/RaiseaFlag";
import AccountOwnerPage from "../Component/Home/AccountOwnerPage/AccountOwnerPage";
import MyAssessment from "../Component/Home/Pms/MyAssessment";
import HrAssessment from "../Component/Home/Pms/HrAssessment";
import AssessmentEmployeeCycles from "../Component/Home/Pms/Assessment_Employee_Cycles";
import TicketManagementList from "../Component/Home/TicketManagement/TicketManagementList";
import TicketDetail from "../Component/Home/TicketManagement/TicketDetail";
import MyTickets from "../Component/Home/TicketManagement/MyTickets";
import AddTicket from "../Component/Home/TicketManagement/AddTicket";
import AuditTrails from "../Component/Home/AuditTrails/AuditTrails";
import MainCropper from "../Component/Home/Gallery/ImageCropperNew/file/MainCropper";
import CreatePosition from "../Component/Home/RecruitmentDashboard/CreatePosition";
import RecruitmentDashboard from "../Component/Home/RecruitmentDashboard/RecruitmentDashboard";
import RecruitmentDetails from "../Component/Home/RecruitmentDashboard/RecruitmentDetails";
import ApplicantDetails from "../Component/Home/RecruitmentDashboard/ApplicantDetails/ApplicantDetails";
import AddApplicant from "../Component/Home/RecruitmentDashboard/ApplicantDetails/AddApplicant";
import ApplicantSearch from "../Component/Home/RecruitmentDashboard/ApplicantDetails/ApplicantSearch";
import JobSearch from "../Component/Home/RecruitmentDashboard/JobListing";
import TaskManagementDashboard from "../Component/Home/TaskManagement/TaskManagementDashboard";
import TaskDetail from "../Component/Home/TaskManagement/TaskDetail";
import SelfLearningDashboard from "../Component/Home/SelfLearning/SelfLearningDashboard/SelfLearningDashboard";
import CourseDetail from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/CourseDetails";
import CourseReviews from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseReviews/CourseReviews";
import Enroll from "../Component/Home/SelfLearning/Enroll";
import AddVideoContent from "../Component/Home/SelfLearning/AddVideoContent";
import AddQuiz from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/AddQuiz";
import LessonDetail from "../Component/Home/SelfLearning/LessonDetail";
import AddNewCourse from "../Component/Home/SelfLearning/SelfLearningDashboard/AddNewCourse/AddNewCourse";
import AddModule from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/AddModule";
import QuizDetail from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/QuizDetail";
import QuizList from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/QuizList";
import QuestionOption from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/OuestionOptionList";
import QuizResult from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/QuizResult";
import AddQuizQuestion from "../Component/Home/SelfLearning/SelfLearningDashboard/CourseDetails/AddQuizQuestion";
import InstructorTrainingDashboard from "../Component/Home/SelfLearning/InstructorTraining/InstructorTrainingDashboard";
import TrainingDetail from "../Component/Home/SelfLearning/InstructorTraining/TrainingDetail";
import AddNewTraining from "../Component/Home/SelfLearning/InstructorTraining/AddNewTraining";
import ScheduleTraning from "../Component/Home/SelfLearning/InstructorTraining/ScheduleTraning";
import TaskList from "../Component/Home/TicketDrag/TicketDrag";
import ArticleDiscussionBoard from "../Component/Home/ArticleDiscussionBoard/ArticleDiscussionBoard";
import ArticleDetail from "../Component/Home/ArticleDiscussionBoard/ArticleDetail";
import ArticleAddEdit from "../Component/Home/ArticleDiscussionBoard/ArticleAddEdit";
import InitiateEmployeeExitList from "../Component/Home/EmployeeExitManagement/InitiateEmployeeExitList";
import EmployeeExitDetails from "../Component/Home/EmployeeExitManagement/EmployeeExitDetails";
import AddInitiateExitEmployee from "../Component/Home/EmployeeExitManagement/AddInitiateExitEmployee";
import InitiateExitEmployeeDetails from "../Component/Home/EmployeeExitManagement/InitiateExitEmployeeDetails";
import Setting from "../Component/Home/Setting/Setting";
import Reports from "../Component/Home/Reports/Reports";
import HrNodeHierarchy from "../Component/Home/ApplyLeave/Employee/HrNodeHierarchy";
import SuggestAfeature from "../Component/Home/Dashboard/SuggestAFeature/SuggestAFeature";
import ManageUserAccess from "../Component/Home/MyProfile/CommonComponents/ManageUserAccess";
import UserFollowingsList from "../Component/Home/MyProfile/UserFollowingsList";
import UserFollowersList from "../Component/Home/MyProfile/UserFollowersList";
import FollowUpSuggestionsList from "../Component/Home/Dashboard/FollowUpSuggestions/FollowUpSuggestionsList";
import Messages from "../Component/Home/Messages/Messages";
import AboutOrggenie from "../Component/Home/AboutOrggenie/AboutOrggenie";
import Legal from "../Component/Home/Legal/Legal";
import Version from "../Component/Home/Version/Version";
import UpdateVersion from "../Component/Home/Version/UpdateVersion";
import AddExperience from "../Component/Home/MyProfile/CommonComponents/AddExperience";
import AddEducation from "../Component/Home/MyProfile/CommonComponents/AddEducation";
import AddCertification from "../Component/Home/MyProfile/CommonComponents/AddCertification";
import AddUserAward from "../Component/Home/MyProfile/CommonComponents/AddUserAward";
import Calendar from "../Component/Home/Calender/Calender";
import "../theme.css";
import Otp from "../Component/Auth/Login/loginByOtp";
import Login from "../Component/Auth/Login/Login";
import SetPassword from "../Component/Auth/Chnage-Password/SetPassword";
import UploadEmployee from "../Component/Home/TeamDirectory/UploadEmployee";
import CancellationSurveyForm from "../Component/Home/AdvanceSetting/SurveyForm";
import ErrorBoundary from "../Services/ErrorBoundary";
import {
  Redirect,
  useHistory,
} from "react-router-dom/cjs/react-router-dom.min";
import Showcase from "../Component/Home/AboutOrggenie/Showcase";
import OrgnizationTeam from "../Component/Home/MyProfile/OrgnizationTeam";
import SubscriptionSetting from "../Component/Home/AdvanceSetting/SubscriptionSetting";
import LeadManagementList from "../Component/Home/LeadManagement/LeadManagementList";
import LeadDetail from "../Component/Home/LeadManagement/LeadDetail";
import MyLeads from "../Component/Home/LeadManagement/MyLead";
import DocumentFile from "../Component/Home/Documents/DocumentFile";
import DocumentDetail from "../Component/Home/Documents/DocumentList";
import AddDocument from "../Component/Home/Documents/AddDocumnet";
import DocumentViewFolder from "../Component/Home/Documents/DocumentViewFolder";
import CreateFolder from "../Component/Home/Documents/CreateFolder";
import UploadDocument from "../Component/Home/Documents/BulkUploadDocument";
import AddLead from "../Component/Home/LeadManagement/AddLead";
import TimesheetList from "../Component/Home/Timesheet/TimesheetList";
import TimesheetHowItWorks from "../Component/Home/Timesheet/TimesheetGuide";
import TimesheetApproval from "../Component/Home/Timesheet/TimesheetApproval";
import TimesheetSummery from "../Component/Home/Timesheet/TimesheetSummery";
import LinkHandler from "../Shared/Mobile_IOS_Linking/Mobile_IOS_Link";
import useAuth from "../Routes/AuthGard/useAuth";
import { usePermissions } from "../Routes/AuthGard/usePermissions";
import ComponentLoader from "../Shared/Sidebar/ComponentLoader";
import AddAssets from "../Component/Home/AssetsRegistration/AddAssets";
import AssetsList from "../Component/Home/AssetsRegistration/AssetsList";
import AssetsDetail from "../Component/Home/AssetsRegistration/AssetsDetail";
import CreateSurvay from "../Component/Home/Survay/CreateSurvey";
import SurvayPreview from "../Component/Home/Survay/SurveyPreview";
import FillSurvey from "../Component/Home/Survay/FillSurvey";
import SurvayList from "../Component/Home/Survay/SurveyList";
import SurvayResult from "../Component/Home/Survay/SurveyResult";
import SurvayResponse from "../Component/Home/Survay/SurveyResponse";
import IndividualSurvey from "../Component/Home/Survay/IndividualSurvey";
import AddDocumnethtml from "../Component/Home/Documents/DiicumentHtml/AddDocumnethtml";
import DocumentViewFolderhtml from "../Component/Home/Documents/DiicumentHtml/DocumentViewFolderhtml";
import UploadDocumenthtml from "../Component/Home/Documents/DiicumentHtml/UploadDocumenthtml";
import DocumentDetailhtml from "../Component/Home/Documents/DiicumentHtml/DocumentDetailhtml";
import DocumentFilehtml from "../Component/Home/Documents/DiicumentHtml/DocumentFilehtml";
import Assessment_Employee_CyclesHTML from "../Component/Home/Pms/Pmshtml/Assessment_Employee_CyclesHTML";
import HrAssessmentHTML from "../Component/Home/Pms/Pmshtml/HrAssessmentHTML";
import Add_New_AssessmentsHTML from "../Component/Home/Pms/Pmshtml/Add_New_AssessmentsHTML";
import EmpAssessmentHTML from "../Component/Home/Pms/Pmshtml/EmpAssessmentHTML";
import MyAssessmentHTML from "../Component/Home/Pms/Pmshtml/MyAssessmentHTML";
import AssessmentCycle from "../Component/Home/Pms/AssessmentCycle";
import AssessmentCycleHTML from "../Component/Home/Pms/Pmshtml/AssessmentCycleHTML";
import DocumentList from "../Component/Home/Documents/DocumentList";
import BulkUploadDocuments from "../Component/Home/Documents/BulkUploadDocument";
import DocumentDragDrop from "../Component/Home/Documents/DragDrop";
import RequestOpenSummary from "../Component/Home/Reports/RequestOpenSummary";
import RequestClosedSummary from "../Component/Home/Reports/RequestClosedSummary";
import EmployeeMissingAttributes from "../Component/Home/Reports/EmployeeMissingAttributes";
import LeaveBalanceReport from "../Component/Home/Reports/LeaveBalanceReport";
import LeaveApplied from "../Component/Home/Reports/LeaveApplied";
import WFHApplied from "../Component/Home/Reports/WFHApplied";
import AddAssetsHtml from "../Component/Home/AssetsRegistration/AddAssetsHtml";
import AssetsDetailHtml from "../Component/Home/AssetsRegistration/AssetsDetailHtml";
import AssetsListHtml from "../Component/Home/AssetsRegistration/AssetsListHtml";
import TeamAssessment from "../Component/Home/Pms/TeamAssessment";
import AddNewAssessment from "../Component/Home/Pms/Add_New_Assessment";
import ChatInput from "../Component/Home/ChatBot1/ChatInput";
import Attendance_Register from "../Component/Home/Attendance/Attendance_Register";
import Attendance_Security from "../Component/Home/Attendance/Attendance_Security";
import Geotag_Employee_Assignment from "../Component/Home/Attendance/Geotag_Employee_Assignment";
import Geotag_Locations from "../Component/Home/Attendance/Geotag_Locations";
import Geotag_Employee_Popup from "../Component/Home/Attendance/Geotag_Employee_Popup";
import My_Attendance from "../Component/Home/Attendance/My_Attendance";
import PayrollDashboard from "../Component/Home/Payroll/PayrollDashboard";
import ArrearManagement from "../Component/Home/Payroll/ArrearManagement";
import EmployeePortal from "../Component/Home/Payroll/Employee-Payroll/EmployeePortal"
import IncentiveManagement from "../Component/Home/Payroll/IncentiveManagement";
import LoanManagement from "../Component/Home/Payroll/LoanManagement";
import ReimbursementManagement from "../Component/Home/Payroll/ReimbursementManagement";
import RunPayroll from "../Component/Home/Payroll/RunPayroll";
import SalaryRegister from "../Component/Home/Payroll/SalaryRegister";
import SalarySlip from "../Component/Home/Payroll/SalarySlip";
import RegularisationList from "../Component/Home/Attendance/RegularisationList";
import PayrollHeader from "../Component/Home/Payroll/Employee-Payroll/payroll-header";
import Self_Mark_Attendance from "../Component/Home/Attendance/Self_Mark_Attendance";
import TashManagementDashboard from "../Component/Home/ProjectManagement/TashManagementDashboard";
import TaskManagementDetails from "../Component/Home/ProjectManagement/TaskManagementProjectDetail";
import TaskManagementList from "../Component/Home/ProjectManagement/TaskManagementList";
import TaskManagementProject from "../Component/Home/ProjectManagement/TaskManagementProject";
import TashManagementTaskDetails from "../Component/Home/ProjectManagement/TashManagementTaskDetails";
import TaskManagementProjectDetail from "../Component/Home/ProjectManagement/TaskManagementProjectDetail";
import TaskMainLayout from "../Component/Home/ProjectManagement/taskMainLayout";
import TaskSidebar from "../Component/Home/ProjectManagement/Tasksidebar";
import ClientList from "../Component/Home/ProjectManagement/ClientList";
import Preloader from "../Shared/Sidebar/Preloader";
import ProjectHelpDescription from "../Component/Home/ProjectManagement/ProjectHelpDescription";
import SprintSection from "../Component/Home/ProjectManagement/SprintSection";
import pastSprints from "../Component/Home/ProjectManagement/PastSprintsSection";
import PastSprintsSection from "../Component/Home/ProjectManagement/PastSprintsSection";
import BackLockSprints from "../Component/Home/ProjectManagement/BackLockSprints";
import CreateSprints from "../Component/Home/ProjectManagement/CreateSprints";
import ProjectRecentActivity from "../Component/Home/Dashboard/CommonComponents/ProjectTeamActivity";
import AddCandidate from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentCandidateAdd";
import RecruiterDashboard from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentDashboard";
import CandidateProfile from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentCandidateProfile";
import InterviewsPage from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentInterviews";
import ScheduleInterview from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentInterviewSchedule";
import CreateJob from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentJobCreate";
import AddCandidateToJob from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentLinkCandidate";
import TalentRequestForm from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentTalentRequestForm";
import TalentRequestsPage from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentTalentRequests";
import RecruitmentCandidates from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentCandidates";
import CVUpload from "../Component/Home/RecruitmentDashboard/recruitment/RecruitmentCVUpload";

const ProtectedLayout = ({ children }) => {
  const location = useLocation();
  const [marginLeft, setMarginLeft] = useState("4.3rem");
  const [marginRight, setMarginRight] = useState("");
  const history = useHistory();

  useEffect(() => {
    const user = localStorage.getItem("User");
    const path = window.location.pathname;

    if (!user && !["/", "/signup", "/user-not-exist"].includes(path)) {
      history?.replace("/");
    }

    const selectedLang = JSON.parse(
      localStorage.getItem("LanguageKey") || "{}",
    );
    if (selectedLang === "ar") {
      document.body.style.direction = "rtl";
      setMarginLeft("0px");
      setMarginRight("4.3rem");
    } else {
      document.body.style.direction = "ltr";
      setMarginLeft("4.3rem");
      setMarginRight("");
    }
  }, []);

  return (
    <div id="main-wrapper" className="show menu-toggle">
      <Sidebar />
      <div
        className="content-body sidemargclass pt-0"
        style={{
          marginLeft,
          marginRight,
        }}
      >
        <Header /> {children}{" "}
      </div>
    </div>
  );
};

const AppRoutes = ({ toster }) => {
  const { loading: checkingAuth, ...perms } = usePermissions();
  const { user, isAuthenticated: userAuthenticated, loading: authLoading } = useAuth();

  if (checkingAuth || authLoading) {
    return <ComponentLoader />;
  }
  return (
    <BrowserRouter>
      <Switch>
        <ProtectedRoute
          path="/OrgSetting/:SettingName"
          component={AdvanceSetting}
          isAuthenticated={perms.isOrgAuthenticated}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          path="/OrgCentral"
          component={OnBoardingDashboard}
          isAuthenticated={perms.isAuthenticated}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/Exit"
          component={InitiateEmployeeExitList}
          isAuthenticated={perms.isInitiateExit}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/Employee/Add"
          component={AddNewEmployee}
          isAuthenticated={perms.employeeCreate}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/Employee/Edit/:GUID"
          component={AddNewEmployee}
          isAuthenticated={perms.employeeCreate}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/AddTicket"
          component={AddTicket}
          isAuthenticated={perms.isAddTicket}
          layout={ProtectedLayout}
        ></ProtectedRoute>{" "}       
        <Route
          exact
          path="/AboutOrg"
          component={AboutOrggenieMobileAccess}
        />
        <Route exact path="/Showcase" component={Showcase} />{" "}       
        <Route
          exact
          path="/"
          render={() =>
            userAuthenticated ? <Redirect to="/dashboard" /> : <Login />
          }
        />
        <Route exact path="/Otp" component={Otp} />
        <Route exact path="/VerifyUser" component={UserNotexit} />
        <Route exact path="/SignUp" component={SignUp} />
        <Route
          exact
          path="/LoginByPassword"
          component={LoginByPassword}
        />
        <ProtectedRoute
          exact
          path="/Dashboard"
          component={Dashboard}
          layout={ProtectedLayout}
        />
        <Route
          path="/ManageUser"
          render={() => (
            <ProtectedLayout>
              <ManageUser />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Gallery"
          render={() => (
            <ProtectedLayout>
              <MainGallery />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Calendar"
          render={() => (
            <ProtectedLayout>
              <Calendar />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/LeaveDashboard/Calendar"
          render={() => (
            <ProtectedLayout>
              <Calendar />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/WFHDashboard/Calendar"
          render={() => (
            <ProtectedLayout>
              <Calendar />
            </ProtectedLayout>
          )}
        />

        <ProtectedRoute
          exact
          path="/AddMedia/:AlbumId"
          component={AddMedia}
          isAuthenticated={perms.isAlbum}
          layout={ProtectedLayout}
        ></ProtectedRoute>{" "}
        <ProtectedRoute
          exact
          path="/CreateAlbum"
          component={CreateAlbum}
          isAuthenticated={perms.isAlbum}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/UpdateAlbum/:AlbumGUID"
          component={CreateAlbum}
          isAuthenticated={perms.isAlbum}
          layout={ProtectedLayout}
        ></ProtectedRoute>{" "}
        <Route
          path="/SingleGallery/:AlbumId"
          render={() => (
            <ProtectedLayout>
              <SingleGallery />
            </ProtectedLayout>
          )}
        />
        {/* <Route
                            path="/SingleGallery/:AlbumId"
                            render={() => (
                              <ProtectedLayout>
                                <SingleGallery />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            exact
                            path="/CreateAlbum"
                            render={() => (
                              <ProtectedLayout>
                                <CreateAlbum />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            exact
                            path="/UpdateAlbum/:AlbumGUID"
                            render={() => (
                              <ProtectedLayout>
                                <CreateAlbum />
                              </ProtectedLayout>
                            )}
                          /> */}{" "}
        {/* {!checkingAuth && ( */}{" "}
        {/* <ProtectedRoute
                            exact
                            path="/Policy/Detail/:GUID"
                            component={Policydetail}
                            // isAuthenticated={perms.isPolicy}
                            layout={ProtectedLayout}
                          /> */}
        <Route
          exact
          path="/Policy/Detail/:GUID"
          render={() => (
            <ProtectedLayout>
              <Policydetail />
            </ProtectedLayout>
          )}
        />{" "}
        {/* )} */}
        <ProtectedRoute
          exact
          path="/AddPolicy"
          component={AddPolicy}
          isAuthenticated={perms.isPolicy}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/EditPolicy/:GUID"
          component={AddPolicy}
          isAuthenticated={perms.isPolicyUpdate}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <Route
          path="/Policylist"
          render={() => (
            <ProtectedLayout>
              <Policylist />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route
                            path="/Policy/Detail/:GUID"
                            render={() => (
                              <ProtectedLayout>
                                <Policydetail />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            path="/AddPolicy"
                            render={() => (
                              <ProtectedLayout>
                                <AddPolicy />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            path="/EditPolicy/:GUID"
                            render={() => (
                              <ProtectedLayout>
                                <AddPolicy />
                              </ProtectedLayout>
                            )}
                          /> */}
        <Route
          path="/Notification"
          render={() => (
            <ProtectedLayout>
              <Notification />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/TeamDirectory"
          render={() => (
            <ProtectedLayout>
              <TeamDirectory />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/UploadEmployee"
          render={() => (
            <ProtectedLayout>
              <UploadEmployee />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/LeaveDashboard"
          render={() => (
            <ProtectedLayout>
              <ApplyLeave />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/UserProfile"
          render={() => (
            <ProtectedLayout>
              <UserProfile />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/OrgnizationTeam"
          render={() => (
            <ProtectedLayout>
              <OrgnizationTeam />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Profile/:UserId"
          render={() => (
            <ProtectedLayout>
              <UserProfile />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Leave"
          render={() => (
            <ProtectedLayout>
              <MyLeave />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/OrganizationLeave"
          render={() => (
            <ProtectedLayout>
              <OrganizationLeave />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/EmployeeList"
          render={() => (
            <ProtectedLayout>
              <EmployeeList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Announcement"
          render={() => (
            <ProtectedLayout>
              <Announcement />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Announcement/Detail/:GUID"
          render={() => (
            <ProtectedLayout>
              <AnnouncementDetail />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route
                            exact
                            path="/Announcement/New"
                            render={() => (
                              <ProtectedLayout>
                                <AnnouncementEdit />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            exact
                            path="/Announcement/Edit/:GUID"
                            render={() => (
                              <ProtectedLayout>
                                <AnnouncementEdit />
                              </ProtectedLayout>
                            )}
                          /> */}
        <ProtectedRoute
          exact
          path="/Announcement/Edit/:GUID"
          component={AnnouncementEdit}
          isAuthenticated={perms.isAnnouncementUpdate}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/Announcement/New"
          component={AnnouncementEdit}
          isAuthenticated={perms.isAnnouncementCreate}
          layout={ProtectedLayout}
        ></ProtectedRoute>{" "}
        {/* <Route
                            exact
                            path="/Announcement/Edit/:GUID"
                            render={() => (
                              <ProtectedLayout>
                                <AnnouncementEdit />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            exact
                            path="/Announcement/New"
                            render={() => (
                              <ProtectedLayout>
                                <AnnouncementEdit />
                              </ProtectedLayout>
                            )}
                          /> */}
        <Route
          path="/Awards"
          render={() => (
            <ProtectedLayout>
              <AwardList />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route
                             path="/Award/Add"
                            render={() => (
                              <ProtectedLayout>
                                <AddAward />
                              </ProtectedLayout>
                            )}
                          /> */}{" "}
        {/* <Route
                            path="/Award/Edit/:AwardId"
                            render={() => (
                              <ProtectedLayout>
                                <AddAward />
                              </ProtectedLayout>
                            )}
                          /> */}
        <ProtectedRoute
          path="/Award/Add"
          component={AddAward}
          isAuthenticated={perms.isAwardCreate}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/Award/Edit/:AwardId"
          component={AddAward}
          isAuthenticated={perms.isAwardUpdate}
          layout={ProtectedLayout}
        ></ProtectedRoute>

        <Route
          path="/Assessment/SelfAssessment/:AssessmentGUID"
          render={() => (
            <ProtectedLayout>
              <MyAssessment />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/TeamAssessment/:AssessmentGUID"
          render={() => (
            <ProtectedLayout>
              <TeamAssessment />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/AddAssessment"
          render={() => (
            <ProtectedLayout>
              <AddNewAssessment />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Assessment/EditAssessment/:GUID"
          render={() => (
            <ProtectedLayout>
              <AddNewAssessment />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AssessmentCycles"
          render={() => (
            <ProtectedLayout>
              <HrAssessment />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/Cycle/Details/:GUID"
          render={() => (
            <ProtectedLayout>
              <AssessmentCycle />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/Employee/Cycles"
          render={() => (
            <ProtectedLayout>
              <AssessmentEmployeeCycles />
            </ProtectedLayout>
          )}
        />


        {/* // Routes */}
        <Route
          path="/Assessment/Employee/AssessmentGUIDHTML"
          render={() => (
            <ProtectedLayout>
              <MyAssessmentHTML />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/Employee/Cycles/teamHTML"
          render={() => (
            <ProtectedLayout>
              <EmpAssessmentHTML />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/AddNewAssessmentHTML"
          render={() => (
            <ProtectedLayout>
              <Add_New_AssessmentsHTML />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/HrAssessmentHTML"
          render={() => (
            <ProtectedLayout>
              <HrAssessmentHTML />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Assessment/CycleGUIDHTML"
          render={() => (
            <ProtectedLayout>
              <AssessmentCycleHTML />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assessment/Employee/CyclesHTML"
          render={() => (
            <ProtectedLayout>
              <Assessment_Employee_CyclesHTML />
            </ProtectedLayout>
          )}
        />
        {/* // ROUTES  */}
        <Route
          exact
          path="/Ticket"
          render={() => (
            <ProtectedLayout>
              <TicketManagementList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Ticket/Detail/:RequestNumber"
          render={() => (
            <ProtectedLayout>
              <TicketDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyTickets"
          render={() => (
            <ProtectedLayout>
              <MyTickets />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Leads"
          render={() => (
            <ProtectedLayout>
              <LeadManagementList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Lead/Detail/:RequestNumber"
          render={() => (
            <ProtectedLayout>
              <LeadDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyLeads"
          render={() => (
            <ProtectedLayout>
              <MyLeads />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AddLead"
          render={() => (
            <ProtectedLayout>
              <AddLead />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AuditTrails"
          render={() => (
            <ProtectedLayout>
              <AuditTrails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MainCropper"
          render={() => (
            <ProtectedLayout>
              <MainCropper />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/CreatePosition"
          render={() => (
            <ProtectedLayout>
              <CreatePosition />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/RecruitmentDashboard"
          render={() => (
            <ProtectedLayout>
              <RecruitmentDashboard />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/PositionDetails"
          render={() => (
            <ProtectedLayout>
              <RecruitmentDetails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ApplicantDetails"
          render={() => (
            <ProtectedLayout>
              <ApplicantDetails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AddApplicant"
          render={() => (
            <ProtectedLayout>
              <AddApplicant />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/ApplicantSearch"
          render={() => (
            <ProtectedLayout>
              <ApplicantSearch />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Add/Award/:AddUserAward"
          render={() => (
            <ProtectedLayout>
              <AddAward /> {/* <AddUserAward /> */}{" "}
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Edit/Award/:AwardId"
          render={() => (
            <ProtectedLayout>
              <AddAward />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Award/Detail/:AwardId"
          render={() => (
            <ProtectedLayout>
              <AwardDetails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ProjectDetail"
          render={() => (
            <ProtectedLayout>
              <ProjectDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Celebrations"
          render={() => (
            <ProtectedLayout>
              <Celebrations />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ChangePassword"
          render={() => (
            <ProtectedLayout>
              <ChangePassword />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/SetPassword"
          render={() => (
            <ProtectedLayout>
              <ChangePassword />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/SetPassword"
          render={() => (
            <ProtectedLayout>
              <SetPassword />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ForgotPassword"
          render={() => (
            <ProtectedLayout>
              <ForgotPassword />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/OTPVerification"
          render={() => (
            <ProtectedLayout>
              <OTPVerification />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyLeaveCompletedLeave"
          render={() => (
            <ProtectedLayout>
              <MyLeaveCompletedLeave />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyLeavePendingLeave"
          render={() => (
            <ProtectedLayout>
              <MyLeavePendingLeave />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/TeamLeave"
          render={() => (
            <ProtectedLayout>
              <TeamLeave />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ApplyForOther"
          render={() => (
            <ProtectedLayout>
              <ApplyLeaveForOther />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/LeaveAdjustment"
          render={() => (
            <ProtectedLayout>
              <LeaveAdjustment />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/WfhApplyForOther"
          render={() => (
            <ProtectedLayout>
              <WFHForOther />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/WFHAdjustment"
          render={() => (
            <ProtectedLayout>
              <WFHAdjustment />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Feed/Featured"
          render={() => (
            <ProtectedLayout>
              <FeaturedPost />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Feed/User/:PostedByGUID"
          render={() => (
            <ProtectedLayout>
              <FeaturedPost />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Feed/Popular"
          render={() => (
            <ProtectedLayout>
              <FeaturedPost />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Feed/Post/:FeedGUID"
          render={() => (
            <ProtectedLayout>
              <FeedDetails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyLedger"
          render={() => (
            <ProtectedLayout>
              <MyLedger />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ledger"
          render={() => (
            <ProtectedLayout>
              <WFHLedger />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Reminders"
          render={() => (
            <ProtectedLayout>
              <Reminders />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/TeamGallery"
          render={() => (
            <ProtectedLayout>
              <TeamGallery />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/CommunicationPanel"
          render={() => (
            <ProtectedLayout>
              <CommunicationPanel />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyWfh"
          render={() => (
            <ProtectedLayout>
              <MyWfh />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyWfhCompleted"
          render={() => (
            <ProtectedLayout>
              <MyWfhCompleted />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyPendingWfh"
          render={() => (
            <ProtectedLayout>
              <MyPendingWfh />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/WfhDashboard"
          render={() => (
            <ProtectedLayout>
              <WfhDashboard />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/TeamWfh"
          render={() => (
            <ProtectedLayout>
              <TeamWfh />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/CreateReminders"
          render={() => (
            <ProtectedLayout>
              <CreateReminders />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/SearchResult"
          render={() => (
            <ProtectedLayout>
              <SearchResult />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SendUsFeedback"
          render={() => (
            <ProtectedLayout>
              <SendUsFeedback />
            </ProtectedLayout>
          )}
        />

        <Route
          exact
          path="/Ticket"
          render={() => (
            <ProtectedLayout>
              <TicketManagementList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Ticket/Detail/:RequestNumber"
          render={() => (
            <ProtectedLayout>
              <TicketDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyTickets"
          render={() => (
            <ProtectedLayout>
              <MyTickets />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Leads"
          render={() => (
            <ProtectedLayout>
              <LeadManagementList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Lead/Detail/:RequestNumber"
          render={() => (
            <ProtectedLayout>
              <LeadDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MyLeads"
          render={() => (
            <ProtectedLayout>
              <MyLeads />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AddLead"
          render={() => (
            <ProtectedLayout>
              <AddLead />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AuditTrails"
          render={() => (
            <ProtectedLayout>
              <AuditTrails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/MainCropper"
          render={() => (
            <ProtectedLayout>
              <MainCropper />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/CreatePosition"
          render={() => (
            <ProtectedLayout>
              <CreatePosition />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/RecruitmentDashboard"
          render={() => (
            <ProtectedLayout>
              <RecruitmentDashboard />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/PositionDetails"
          render={() => (
            <ProtectedLayout>
              <RecruitmentDetails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/ApplicantDetails"
          render={() => (
            <ProtectedLayout>
              <ApplicantDetails />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/AddApplicant"
          render={() => (
            <ProtectedLayout>
              <AddApplicant />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/ApplicantSearch"
          render={() => (
            <ProtectedLayout>
              <ApplicantSearch />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Positions"
          render={() => (
            <ProtectedLayout>
              <JobSearch />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/InstructorTrainingDashboard"
          render={() => (
            <ProtectedLayout>
              <InstructorTrainingDashboard />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/InstructorTrainingDashboard/TrainingDetail/:id"
          render={() => (
            <ProtectedLayout>
              <TrainingDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/InstructorTrainingDashboard/AddNewTraining"
          render={() => (
            <ProtectedLayout>
              <AddNewTraining />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/InstructorTrainingDashboard/TrainingDetail/ScheduleTraning/:id"
          render={() => (
            <ProtectedLayout>
              <ScheduleTraning />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/ManageUserAccess"
          render={() => (
            <ProtectedLayout>
              <ManageUserAccess />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/TaskList"
          render={() => (
            <ProtectedLayout>
              <TaskList />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Articles"
          render={() => (
            <ProtectedLayout>
              <ArticleDiscussionBoard />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route
                            path="/Artical/Add"
                            render={() => (
                              <ProtectedLayout>
                                <ArticleAddEdit />
                              </ProtectedLayout>
                            )}
                          /> */}{" "}
        {/* <Route
                            path="/Artical/Edit/:articleId/:Archived"
                            render={() => (
                              <ProtectedLayout>
                                <ArticleAddEdit />
                              </ProtectedLayout>
                            )}
                          /> */}
        <ProtectedRoute
          exact
          path="/Artical/Add"
          component={ArticleAddEdit}
          isAuthenticated={perms.isArticle}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/Artical/Edit/:articleId/:Archived"
          component={ArticleAddEdit}
          isAuthenticated={perms.isArticle}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <Route
          path="/Article/Detail/:articleId/:Archived"
          render={() => (
            <ProtectedLayout>
              <ArticleDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Article/Detail/:articleId/"
          render={() => (
            <ProtectedLayout>
              <ArticleDetail />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route
                            exact
                            path="/Exit"
                            render={() => (
                              <ProtectedLayout 
                              <ProtectedRoute={isInitiateExit}>
                                <InitiateEmployeeExitList />
                              </ProtectedLayout>

                            )}
       /> */}
        {/* path="/Employee/Exit/:ExitId/:EmpId/:OrgId" */}
        <Route
          exact
          path="/Employee/Exit/:ExitGUID"
          render={() => (
            <ProtectedLayout>
              <EmployeeExitDetails />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route path="/EmployeeExitDetails/:ExitEmpId/:EmpId" render={() => <ProtectedLayout><EmployeeExitDetails /></ProtectedLayout>} /> */}
        <Route
          exact
          path="/Exit/Initiate/:EmpGUID"
          render={() => (
            <ProtectedLayout>
              <AddInitiateExitEmployee />
            </ProtectedLayout>
          )}
        />{" "}
        {/* <Route path="/AddInitiateExitEmployee" render={() => <ProtectedLayout><AddInitiateExitEmployee /></ProtectedLayout>} /> */}
        <Route
          exact
          path="/Exit/Employee/Details/:ExitId"
          render={() => (
            <ProtectedLayout>
              <InitiateExitEmployeeDetails />
            </ProtectedLayout>
          )}
        />
        {/* <Route path="/InitiateExitEmployeeDetails" render={() => <ProtectedLayout><InitiateExitEmployeeDetails /></ProtectedLayout>} /> */}
        <Route
          path="/Settings"
          render={() => (
            <ProtectedLayout>
              <Setting />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Reports"
          render={() => (
            <ProtectedLayout>
              <Reports />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Report/Request/OpenSummary"
          render={() => (
            <ProtectedLayout>
              <RequestOpenSummary />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Report/Request/ClosedSummary"
          render={() => (
            <ProtectedLayout>
              <RequestClosedSummary />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Report/Profile/MissingAttributes"
          render={() => (
            <ProtectedLayout>
              <EmployeeMissingAttributes />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Report/DayOff/LeaveAndWFHBalance"
          render={() => (
            <ProtectedLayout>
              <LeaveBalanceReport />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Report/DayOff/WFHSummary"
          render={() => (
            <ProtectedLayout>
              <WFHApplied />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Report/DayOff/LeaveSummary"
          render={() => (
            <ProtectedLayout>
              <LeaveApplied />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/HrNodeHierarchy"
          render={() => (
            <ProtectedLayout>
              <HrNodeHierarchy />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/RaiseaFlag"
          render={() => (
            <ProtectedLayout>
              <RaiseaFlag />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/SuggestAfeature"
          render={() => (
            <ProtectedLayout>
              <SuggestAfeature />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Followings/:UserId"
          render={() => (
            <ProtectedLayout>
              <UserFollowingsList />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Followers/:UserId"
          render={() => (
            <ProtectedLayout>
              <UserFollowersList />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Follow/Suggestion"
          render={() => (
            <ProtectedLayout>
              <FollowUpSuggestionsList />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Messages"
          render={() => (
            <ProtectedLayout>
              <Messages />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/About"
          render={() => (
            <ProtectedLayout>
              <AboutOrggenie />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Version"
          render={() => (
            <ProtectedLayout>
              <Version />
            </ProtectedLayout>
          )}
        />
        <ProtectedRoute
          exact
          path="/Upgrade"
          component={UpdateVersion}
          isAuthenticated={perms.isVersion}
          layout={ProtectedLayout}
        ></ProtectedRoute>
        <ProtectedRoute
          exact
          path="/EditVersion/:GUID"
          component={UpdateVersion}
          isAuthenticated={perms.isVersion}
          layout={ProtectedLayout}
        ></ProtectedRoute>{" "}
        {/* <Route
                            exact
                            path="/Upgrade"
                            render={() => (
                              <ProtectedLayout>
                                <UpdateVersion />
                              </ProtectedLayout>
                            )}
                          />
                          <Route
                            exact
                            path="/EditVersion/:GUID"
                            render={() => (
                              <ProtectedLayout>
                                <UpdateVersion />
                              </ProtectedLayout>
                            )}
                          /> */}
        <Route
          exact
          path="/AddExperience"
          render={() => (
            <ProtectedLayout>
              <AddExperience />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/AddEducation"
          render={() => (
            <ProtectedLayout>
              <AddEducation />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/AddCertification"
          render={() => (
            <ProtectedLayout>
              <AddCertification />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Experience/:GUID"
          render={() => (
            <ProtectedLayout>
              <AddExperience />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Education/:GUID"
          render={() => (
            <ProtectedLayout>
              <AddEducation />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Certifecation/:GUID"
          render={() => (
            <ProtectedLayout>
              <AddCertification />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard"
          render={() => (
            <ProtectedLayout>
              <SelfLearningDashboard />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/:id"
          render={() => (
            <ProtectedLayout>
              <CourseDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/CourseReviews/:id"
          render={() => (
            <ProtectedLayout>
              <CourseReviews />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Enroll"
          render={() => (
            <ProtectedLayout>
              <Enroll />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SubscriptionSetting"
          render={() => (
            <ProtectedLayout>
              <SubscriptionSetting />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/AddNewCourse"
          render={() => (
            <ProtectedLayout>
              <AddNewCourse />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/AddVideoContent/:id"
          render={() => (
            <ProtectedLayout>
              <AddVideoContent />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/AddQuiz/:id/:moduleId"
          render={() => (
            <ProtectedLayout>
              <AddQuiz />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/AddVideoContent/:id/:moduleId"
          render={() => (
            <ProtectedLayout>
              <AddVideoContent />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/AddQuiz/:id"
          render={() => (
            <ProtectedLayout>
              <AddQuiz />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/LessonDetails/:id"
          render={() => (
            <ProtectedLayout>
              <LessonDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/AddModule/:id"
          render={() => (
            <ProtectedLayout>
              <AddModule />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/QuizDetails/:id/:moduleId"
          render={() => (
            <ProtectedLayout>
              <QuizDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/QuizList/:id/:moduleId"
          render={() => (
            <ProtectedLayout>
              <QuizList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/QuestionOption/:id/:moduleId"
          render={() => (
            <ProtectedLayout>
              <QuestionOption />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/QuizDetails/QuizResult/:id"
          render={() => (
            <ProtectedLayout>
              <QuizResult />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/SelfLearningDashboard/CourseDetails/QuizQuestion/:id"
          render={() => (
            <ProtectedLayout>
              <AddQuizQuestion />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Documents"
          render={() => (
            <ProtectedLayout>
              <DocumentFile />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/DocumentList/:Id"
          render={() => (
            <ProtectedLayout>
              <DocumentList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Document/DragDrop"
          render={() => (
            <ProtectedLayout>
              <DocumentDragDrop />
            </ProtectedLayout>
          )}
        />
        {/* <Route exact path = "/AddDocument/:FolderId"
    render = {
      () => ( <ProtectedLayout >
        <AddDocument / >
        </ProtectedLayout>
      )
    }
    />

    <Route exact path = "/EditDocument/:FolderId/:documentId"
    render = {
      () => ( <ProtectedLayout >
        <AddDocument / >
        </ProtectedLayout>
      )
    }
    /> */}
        <Route
          exact
          path="/Timesheet/Entry"
          render={() => (
            <ProtectedLayout>
              <TimesheetList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Timesheet/Approval"
          render={() => (
            <ProtectedLayout>
              <TimesheetApproval />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Timesheet/Summary"
          render={() => (
            <ProtectedLayout>
              <TimesheetSummery />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Document/View/:Id"
          render={() => (
            <ProtectedLayout>
              <DocumentViewFolder />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/BulkUploadDocument/:Id"
          render={() => (
            <ProtectedLayout>
              <BulkUploadDocuments />
            </ProtectedLayout>
          )}
        />
        {/* <Route exact path = "/Create/Folder"
    render = {
      () => ( <ProtectedLayout >
        <CreateFolder / >
        </ProtectedLayout>
      )
    }
    /> */}
        <Route
          exact
          path="/Documenthtml"
          render={() => (
            <ProtectedLayout>
              <DocumentFilehtml />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/DocumentDetailhtml"
          render={() => (
            <ProtectedLayout>
              <DocumentDetailhtml />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/AddDocumenthtml"
          render={() => (
            <ProtectedLayout>
              <AddDocumnethtml />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/DocumentViewhtml"
          render={() => (
            <ProtectedLayout>
              <DocumentViewFolderhtml />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/BulkUploadDocumenthtml"
          render={() => (
            <ProtectedLayout>
              <UploadDocumenthtml />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Timesheet/Entry"
          render={() => (
            <ProtectedLayout>
              <TimesheetSummery />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Timesheet/Approval"
          render={() => (
            <ProtectedLayout>
              <TimesheetApproval />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Timesheet/Report"
          render={() => (
            <ProtectedLayout>
              <TimesheetList />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Timesheet/TimesheetHowItWorks"
          render={() => (
            <ProtectedLayout>
              <TimesheetHowItWorks />
            </ProtectedLayout>
          )}
        />

        
        <Route
          path="/CancellationSurveyForm"
          render={() => (
            <ProtectedLayout>
              <CancellationSurveyForm />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/NotAuthorized"
          render={() => (
            <ProtectedLayout>
              <UserAuthorisation />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/LinkTest"
          render={() => (
            <ProtectedLayout>
              <LinkHandler />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assets/Add"
          render={() => (
            <ProtectedLayout>
              <AddAssets />
            </ProtectedLayout>
          )}
        />
        <Route
          exact
          path="/Assets/Edit/:GUId"
          render={() => (
            <ProtectedLayout>
              <AddAssets />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assets/AddHtml"
          render={() => (
            <ProtectedLayout>
              <AddAssetsHtml />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assets/List"
          render={() => (
            <ProtectedLayout>
              <AssetsList />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assets/ListHtml"
          render={() => (
            <ProtectedLayout>
              <AssetsListHtml />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assets/Detail/:guid"
          render={() => (
            <ProtectedLayout>
              <AssetsDetail />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Assets/DetailHtml"
          render={() => (
            <ProtectedLayout>
              <AssetsDetailHtml />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/Create"
          render={() => (
            <ProtectedLayout>
              <CreateSurvay />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/Update/:SurveyFormId"
          render={() => (
            <ProtectedLayout>
              <CreateSurvay />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/List"
          render={() => (
            <ProtectedLayout>
              <SurvayList />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/Result/:SurveyFormId"
          render={() => (
            <ProtectedLayout>
              <SurvayResult />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/Form/:SurveyFormId"
          render={() => (
            <ProtectedLayout>
              <FillSurvey />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/Preview/:SurveyFormId"
          render={() => (
            <ProtectedLayout>
              <SurvayPreview />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Survey/IndividualSurvey/:SurveyFormId/:UserId"
          render={() => (
            <ProtectedLayout>
              <IndividualSurvey />
            </ProtectedLayout>
          )}
        />


        <Route
          path="/Attendance-Register"
          render={() => (
            <ProtectedLayout>
              <Attendance_Register />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Self-Mark-Attendance"
          render={() => (
            <ProtectedLayout>
              <Self_Mark_Attendance />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Attendance-Security"
          render={() => (
            <ProtectedLayout>
              <Attendance_Security />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Geotag-Employee-Assignment/:LocationAssignedId"
          render={() => (
            <ProtectedLayout>
              <Geotag_Employee_Assignment />
            </ProtectedLayout>
          )}
        />

        <Route exact
          path="/Geotag-Locations"
          render={() => (
            <ProtectedLayout>
              <Geotag_Locations />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Geotag-Employee_Popup"
          render={() => (
            <ProtectedLayout>
              <Geotag_Employee_Popup />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/My-Attendance"
          render={() => (
            <ProtectedLayout>
              <My_Attendance />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Attendance-Regularization"
          render={() => (
            <ProtectedLayout>
              <RegularisationList />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Survey/Response/:SurveyFormId"
          render={() => (
            <ProtectedLayout>
              <SurvayResponse />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Dashboard"
          render={() => (
            <ProtectedLayout>
              <PayrollDashboard />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Arrear-Management"
          render={() => (
            <ProtectedLayout>
              <ArrearManagement />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Employee-Login"
          render={() => (
            <ProtectedLayout>
              <EmployeePortal />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Payroll/Employee-Dashboard"
          render={() => (
            <ProtectedLayout>
              <PayrollHeader />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Incentive-Management"
          render={() => (
            <ProtectedLayout>
              <IncentiveManagement />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Loan-Management"
          render={() => (
            <ProtectedLayout>
              <LoanManagement />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Run-Payroll"
          render={() => (
            <ProtectedLayout>
              <RunPayroll />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Salary-Register"
          render={() => (
            <ProtectedLayout>
              <SalaryRegister />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Payroll/Salary-Slip/:EmpId/:month"
          render={() => (
            <ProtectedLayout>
              <SalarySlip />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Help"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <ProjectHelpDescription />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Dashboard"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TashManagementDashboard />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Project/List/:ClientGUID"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TaskManagementProject />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Project/List"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TaskManagementProject />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Detail/:projId"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TaskManagementProjectDetail />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Project/Task/List"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TaskManagementList />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Project/Tasks/:ProjectGUID"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TaskManagementList />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Project/Tasks/All"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TaskManagementList />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Task/Detail/:id"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <TashManagementTaskDetails />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Clients"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <ClientList />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Sprint"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <SprintSection />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/PastSprints"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <PastSprintsSection />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Sprints"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <CreateSprints />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/Backlog/:ProjectGUID"
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <BackLockSprints />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Reimbursement-Management"
          exact
          render={() => (
            <ProtectedLayout>
              <ReimbursementManagement />
            </ProtectedLayout>
          )}
        />



        <Route
          path="/Recruitment/Reimbursement-Dadhboard"
          exact
          render={() => (
            <ProtectedLayout>
              <RecruiterDashboard />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Recruitment-Candidate-Add"
          exact
          render={() => (
            <ProtectedLayout>
              <AddCandidate />
            </ProtectedLayout>
          )}
        />
        <Route
          path="/Recruitment/Candidate"
          exact
          render={() => (
            <ProtectedLayout>
              <RecruitmentCandidates />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Candidate-Profile"
          exact
          render={() => (
            <ProtectedLayout>
              <CandidateProfile />
            </ProtectedLayout>
          )}
        />
            <Route
          path="/Recruitment/Candidate-CVUpload"
          exact
          render={() => (
            <ProtectedLayout>
              <CVUpload />
            </ProtectedLayout>
          )}
        />


        <Route
          path="/Recruitment/Reimbursement-Interview"

          render={() => (
            <ProtectedLayout>
              <InterviewsPage />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Reimbursement-Interview/Schedule"
          exact
          render={() => (
            <ProtectedLayout>
              <ScheduleInterview />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Reimbursement-Job/Create"

          render={() => (
            <ProtectedLayout>
              <CreateJob />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Reimbursement-Link/Candidate"
          exact
          render={() => (
            <ProtectedLayout>
              <AddCandidateToJob />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Talent-Request-Form"
          exact
          render={() => (
            <ProtectedLayout>
              <TalentRequestForm />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Recruitment/Talent-Requests-Page"
          exact
          render={() => (
            <ProtectedLayout>
              <TalentRequestsPage />
            </ProtectedLayout>
          )}
        />

        <Route
          path="/Project/ProjectRecentActivity"
          exact
          render={() => (
            <ProtectedLayout>
              <TaskMainLayout>
                <ProjectRecentActivity />
              </TaskMainLayout>
            </ProtectedLayout>
          )}
        />
        {/* Catch-all for unmatched routes */}
        <Route component={Pagenotfound} />
      </Switch>

      <Preloader />
    </BrowserRouter>
  );
};

export default AppRoutes;